import apiBase from './apiBase';

class ParcelsApi {
  static loadParcels(budgetId, query) {
    return apiBase.get(`/public/budget/${budgetId}/parcels?query=${query}`);
  }
}

export default ParcelsApi;



// WEBPACK FOOTER //
// ./src/api/parcelsApi.js